import { Link } from 'react-router-dom';
import { Checkbox } from '@/components/ui/checkbox';

interface RefundWaiverProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Required consent before the payment form is shown. Digital files are
 * delivered immediately, so the buyer waives the right of withdrawal.
 */
export const RefundWaiver = ({ checked, onChange }: RefundWaiverProps) => (
  <div className="border border-border/60 bg-secondary/20 p-4 sm:p-5">
    <label className="flex items-start gap-3 cursor-pointer">
      <Checkbox
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
        aria-label="Accept the non-refundable digital delivery terms"
        className="mt-0.5 rounded-none"
      />
      <span className="text-sm font-light leading-relaxed text-foreground">
        I understand these are digital files delivered immediately, and that by
        completing this purchase I waive my right of withdrawal &mdash; the order
        is non-refundable.
      </span>
    </label>
    <p className="mt-3 pl-7 text-[11px] font-light text-muted-foreground/80">
      Broken or missing files are always put right.{' '}
      <Link to="/terms" className="underline underline-offset-2 hover:text-foreground">
        Read the terms
      </Link>
    </p>
  </div>
);
